import {Tab, Tabs} from 'react-bootstrap'
import {Link, useParams} from 'react-router-dom'
import {
  useGetDetailCompletedBatchQuery,
  useGetErrorDetailBatchQuery,
} from '../../../../../redux/api/services/batch'
import CustomTable from '../../../../../helpers/elements/table/CustomTable'
import {TitleCard} from '../../../../../helpers/elements/card/TitleCard'
import {
  completedDetailsColumns,
  errorDetailColumns,
} from '../../../../../helpers/elements/table/columns/_columns'
import {useSelector} from 'react-redux'
import {RootState} from '../../../../../redux/store'
import {CustomErrorAlert} from '../../../../../libs/_fri/components/CustomErrorAlert/CustomErrorAlert'

const HistoryDetailPage = () => {
  const {id} = useParams()
  const infoState = useSelector((state: RootState) => state.info)

  const completedBatchDetailStatus = useGetDetailCompletedBatchQuery({
    info: infoState,
    requestContent: {batchId: id || ''},
  })

  const errorBatchDetailStatus = useGetErrorDetailBatchQuery({
    info: infoState,
    requestContent: {batchId: id || ''},
  })

  return (
    <>
      <TitleCard
        title='Detalle del pago'
        subtitle='Listado de pagos - Detalle'
        goBack='/history/list'
      />
      <div className='card'>
        <div className='card-body'>
          {id && (
            <Tabs defaultActiveKey='schedule' className='mb-3'>
              <Tab
                eventKey='schedule'
                title={`Pagos realizados (${
                  completedBatchDetailStatus.data?.responseContent.records.length || 0
                })`}
                className='mt-14'
              >
                <CustomErrorAlert
                  error={completedBatchDetailStatus.error}
                  show={completedBatchDetailStatus.isError}
                />
                <CustomTable
                  batchList={completedBatchDetailStatus.data?.responseContent.records || []}
                  isLoading={completedBatchDetailStatus.isLoading}
                  columns={completedDetailsColumns}
                />
              </Tab>
              <Tab
                eventKey='batchErrorsDetail'
                title={`Registos inválidos (${
                  errorBatchDetailStatus.data?.responseContent.errors.length || 0
                })`}
              >
                <CustomErrorAlert
                  error={errorBatchDetailStatus.error}
                  show={errorBatchDetailStatus.isError}
                />
                <CustomTable
                  batchList={errorBatchDetailStatus.data?.responseContent.errors || []}
                  isLoading={errorBatchDetailStatus.isLoading}
                  columns={errorDetailColumns}
                />
              </Tab>
            </Tabs>
          )}
        </div>
      </div>
    </>
  )
}

export {HistoryDetailPage}
